import { FunctionComponent, useRef, useEffect } from 'react';
import RailzConnect from '@railzai/railz-connect';
import { useClientData } from '../../../../providers/ClientData.provider';
import RailzConnectType from './railz-connect';
import styles from './RailzConnect.module.scss';

export type RailzConnectProps = {
  redirectURL: string;
};
type FC = FunctionComponent<RailzConnectProps>;
const RailzConnectFrame: FC = ({ redirectURL }: RailzConnectProps) => {
  const { response } = useClientData();
  const ref = useRef(null);
  const widgetId = import.meta.env.VITE_RAILZ_WIDGET_ID;
  useEffect(() => {
    const widget: RailzConnectType = new (RailzConnect as typeof RailzConnectType)();
    widget.mount({
      parentElement: ref.current,
      widgetId,
      businessName: response.AccountID,
      brandColor: '000000',
      accentColor: 'FFFFFF',
      language: 'en',
      redirectUrl: `${redirectURL}`,
      closeRedirectUrl: `${redirectURL}`,
      removeRailzWatermark: true,
      closeEnabled: true,
    });
  }, []);
  return <div className={styles.railzConnectContainer} id="railz-connect" ref={ref} />;
};
export default RailzConnectFrame;
